import Slider from 'react-slick';
import { useState, useEffect } from 'react';
import './Reviews.css'
import { arrow } from '@popperjs/core';
import { useTranslation } from 'react-i18next';


function Reviews() {
    const [reviews, setReviews] = useState({})
    const getData = async () => {
        await fetch('recenzje_oferteo.json'
            , {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            }
        )
            .then(function (response) {
                return response.json();
            })
            .then(function (myJson) {
                setReviews(myJson)
            });
    }
    useEffect(() => {
        getData()
    }, [])

    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
    }

    const { t } = useTranslation()

    return (
        <>
            <section className="container-fluid reviews" style={{ backgroundColor: "#2c2c2c", color: "#f6f6f6" }} id='section_2'>
                <section className="container-lg h-100">
                    <div className="row h-100 py-5">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 reviews-panel__section" data-aos="fade-up">
                            <h6 className='m-0 mb-5 fw-lighter'>({t("reviews.header")})</h6>
                            <Slider {...settings}>
                                {reviews.oferteo ? (
                                    reviews.oferteo && Object.keys(reviews.oferteo).map(key => {
                                        const item = reviews.oferteo[key];
                                        return (
                                            <div className='mt-5'>
                                                <h5 className='m-0 fw-bold'>{item.data}</h5>
                                                <h5 className='m-0 fw-bold'>{item.nazwa}</h5>
                                                <div key={key} className="mt-4 mx-auto d-flex flex-column justify-content-between reviews-panel__body">
                                                    <p className='text-center h-50 fw-light'>{item.opis}</p>
                                                    <div className='d-flex justify-content-center align-items-center'>
                                                        {Array.from({ length: item.ocena }, (_, index) => (
                                                            <img src="icons/star.svg" alt="star" width={32} height={32} />
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                ) : (
                                    <p>wczytwynanie</p>
                                )}
                            </Slider>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 reviews-panel__image-container" data-aos="fade-up">
                            <img src="images/ogrodzenia-2.webp" class="reviews-image-1" alt="Elewacje Kamienne" />
                            <img src="images/home-photo-2.webp" class="reviews-image-2" alt="Artystyczne budowle kamienne" />
                            <img src="images/domniemcy.jpg" class="reviews-image-3" alt="Zamek wybudowany z kamienia naturalnego" />
                            <img src="images/elewacjanorwegia.jpg" class="reviews-image-4" alt="Dom z kamienia naturalnego" />
                            <img src="images/459709_1492376140581_o.jpg" class="reviews-image-5" alt="Wykorzystanie kamienia naturalnego w domu" />
                        </div>
                    </div>
                </section>
            </section>


            <section className="container-fluid" style={{ backgroundColor: "#2c2c2c", color: "#f6f6f6", paddingTop: "16px", paddingBottom: "16px" }}>
                <section className="container-lg">
                    <div className="row">
                        <hr style={{ opacity: 1, width: "87.5%", marginTop: "16px" }} className='mx-auto' />
                        <div className='text-center'>
                            <h5 className='m-0 fw-medium'>{t("reviews.text1")}</h5>
                            <h6 className='m-0 p-0 fw-lighter'><a target='_blank'>https://www.favore.pl</a></h6>

                            <div className='d-flex my-4 justify-content-center align-items-center'>
                                <img src="icons/star.svg" alt="Ocena" width={38} />
                                <img src="icons/star.svg" alt="Ocena" width={38} />
                                <img src="icons/star.svg" alt="Ocena" width={38} />
                                <img src="icons/star.svg" alt="Ocena" width={38} />
                                <img src="icons/star.svg" alt="Ocena" width={38} />
                            </div>
                            <p className='m-0 p-0'>
                                {t("reviews.text2")}
                            </p>
                        </div>
                    </div>
                </section>
            </section>
        </>
    )
}

export default Reviews